// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3Xx6j","containerItemsCenter":"Skeleton_containerItemsCenter__1NVHX"};